export var binDocs = {
  name: 'bin',
  category: 'Utils',
  syntax: ['bin(value)'],
  description: 'Format a number as binary',
  examples: ['bin(2)'],
  seealso: ['oct', 'hex']
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/expression/embeddedDocs/function/utils/bin.js
// module id = null
// module chunks = 